import React, { createContext, useState } from 'react'
import { initialContextState } from './initialContextState'
import { useMap } from '@vis.gl/react-google-maps'
import CountyFeature from '../../views/Map/RightSider/Options/RACsAndCountiesOption/types/CountyFeature'

// Create Context
export const MapSettingsContext: any = createContext({ ...initialContextState })

// Create a provider for component to consume and subscribe to changes
export const ContextProvider = (props: any) => {
  const map = useMap()

  const [selectedCollections, setSelectedCollections] = useState<number[]>([])

  const [activeCounties, setActiveCounties] = useState<Map<string, CountyFeature>>(new Map())

  const [selectedVehicleHistory, setSelectedVehicleHistory] = useState<number | undefined>()

  const [followedVehicleId, setFollowedVehicleId] = useState<number | undefined>()

  const [selectedVehicleId, setSelectedVehicleId] = useState<number | undefined>()

  const [directionsOpen, setDirectionsOpen] = useState<boolean>(true)

  // const routeListener = new BehaviorSubject<{lat: number, lng: number} | undefined>(undefined)

  return (
    <MapSettingsContext.Provider
      value={{
        map,
        selectedCollections,
        setSelectedCollections,
        activeCounties,
        setActiveCounties,
        selectedVehicleHistory,
        setSelectedVehicleHistory,
        followedVehicleId,
        setFollowedVehicleId,
        selectedVehicleId,
        setSelectedVehicleId,
        directionsOpen,
        setDirectionsOpen,
      }}
    >
      {props.children}
    </MapSettingsContext.Provider>
  )
}
